import { PageFooterComponents } from '@my-types';
import { React, Styled } from '@common/3rd';
import { PATH, Utils, Envs } from '@common';
import { PageFooter } from '@component';
import { StyledComponents } from '@styles';
import qr from '@images/mej/mej-footer-qr.png';
import logo from '@images/mej/mej-footer-logo.png';
import footer1 from '@images/mej/mej-footer-1.png';
// import footer2 from '@images/mej/mej-footer-2.png';
import footer3 from '@images/mej/mej-footer-3.png';
const Footer = Styled.div.attrs({ 'data-widget': 'page-footer' })`
	width: 100vw;
	padding: 50px 140px 30px 140px;
	background: rgb(35, 31, 32);
	display: flex;
	& > div {
		flex: 1;
		&:first-child {
			display: flex;
			img {
				width: 120px;
				height: 120px;
			}
			[data-widget="fas"] {
				font-size: 24px;
			}
			& > div {
				margin-left: 30px;
				> div {
					display: flex;
					align-items: flex-start;
					margin-top: 5px;
					p {
						margin-left: 10px;
						line-height: 1.5;
						color: #666;
					}
				}
			}
		}
		&:last-child {
			text-align: right;
			.link-wrapper {
				display: flex;
				justify-content: flex-end;
				line-height: 20px;
				margin-bottom: 8px;
				button {
					cursor: pointer;
					font-size: 14px;
					color: inherit;
					padding: 0 10px;
					// border-left: 1px solid #fff;
					background: transparent;
					border-top: 0;
					position: relative;
					border: 0;
					&:before {
						display: block;
						content: '';
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
						width: 1px;
						height: 14px;
						background: #fff;
					}
					&:last-child {
						padding-right: 0;
						&:before {
							display: none;
						}
					}
				}
			}
			.copyright {
				line-height: 18px;
				font-size: 12px;
				margin-bottom: 8px;
				span {
					cursor: pointer;
					> img {
						vertical-align: middle;
					}
				}
			}
			.img-wrapper > a {
				position: relative;
				cursor: pointer;
				> img {
					width: 76px;
				}
			}
			> img {
				width: 180px;
			}
		}
	}
	.white {
		color: #fff;
	}
	.grey {
		color: #999;
	}
	.bold {
		font-weight: bold;
	}
	.center {
		text-align: center;
	}
`
/**
 * 桌面页脚
 */
class DeskPageFooter<P, S, C extends PageFooterComponents> extends PageFooter<
	P,
	S,
	C
> {
	render() {
		const hideHeaderAndFooter = Envs.isPhone() && ['disclosure/agreement', 'disclosure/statement', 'disclosure/cookie'].some((path: string) => window.location.href.includes(path));
		return hideHeaderAndFooter ? <></> : (
			<Footer>
				<div>
					<img src={qr} alt="qr" />
					<div>
						<div>
							<StyledComponents.FAS icon="phone" className="grey" />
							<p>
								<span>服务热线</span><br/>
								<span className="white">0512-89579498</span><br/>
								<span>工作日 9:00-12:00 13:00-18:00</span>
							</p>
						</div>
						<div>
							<StyledComponents.FAS icon="envelope" className="grey" />
							<p>
								<span>客服邮箱</span><br/>
								<span className="white">service@mej.cn</span>
							</p>
						</div>
					</div>
				</div>
				<div>
					<img src={logo} alt="MarshMcLennan" onClick={() => {
						window.open('https://mmc.com', '_blank');
					}} />
					<div className="white link-wrapper">
						<button onClick={() => {
							this.getHelpers().getRouter().pushRedirect(PATH.DESK2_ABOUT_US);
						}}>关于我们</button>
						<button onClick={() => {
							let qs = Utils.fromQueryString();
							if (window.location.href.includes(PATH.DESK2_DISCLOSURE_MAIN) && qs.tag === 'copyright') {
								delete qs.tag;
								window.location.href =  window.location.href.split('?')[0] + '?' + Utils.toQueryString({
									...qs
								});
							} else {
								this.getHelpers().getRouter().pushRedirect(PATH.DESK2_DISCLOSURE_MAIN);
							}
						}}>信息披露</button>
						<button onClick={() => {
							let qs = Utils.fromQueryString();
							if (window.location.href.includes(PATH.DESK2_DISCLOSURE_MAIN) && qs.tag !== 'copyright') {
								window.location.href = window.location.href.split('?')[0] + '?' + Utils.toQueryString({
									...qs,
									tag: 'copyright'
								});
							} else {
								this.getHelpers().getRouter().pushRedirect(PATH.DESK2_DISCLOSURE_MAIN + '?tag=copyright');
							}
						}}>版权声明</button>
						<button onClick={() => {
							this.getHelpers().getRouter().pushRedirect(PATH.DESK2_COOKIE_STATEMENT);
						}}>COOKIE声明</button>
					</div>
					<div className="white copyright right">
						&copy;{(new Date()).getFullYear()} MERCER, All Rights Reserved<br/>
						<span onClick={() => {
							window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
						}}>沪ICP备15004915号-5</span><br/>
						<span onClick={() => {
							window.open("https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102005101", "_blank");
						}}>
							<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAQZSURBVDiNbZNdbFNlHMaf9z1vz+np11nP2rWDQdnWDRjblAFTiEbM4keExMVMgsZB4oWacCFcGA1+ZAYSLoxRLzTBhOiNGUEyzEgIKgFGjKAwjIky7Gi2Qbe1Y23PttOenp6P1ytAwP/Vc/N78vwvfgQPHOcD9PznWmjl5k1R0a70Xr2c2mFZROzclDgmhmJDf/30c3bbe18tEkKc/3LkoaLyyJaxU6ffuHwu3eMaE5GZqgyhRiHLVQlm3lfsfjJxtoN27CI7dtxXRO8tAeGckzOHj/y4951zuxf1yYY1guXt5xnv63RK2twWkJQuNf7u/pFXT+fTKx4cQO9FDmA+fuSEjm19DXgpXkLg6Di0CRfFmw70t46ix0lh9yfbsaWbfsH5uPS/r82nP+0ZOpk7zhcyNS//8wuyw0UgqYLfrsAp2aAtCirXZtDQuwqtw8/i4Adyceczcm9d18AFAGBXrhz21LuxuJgePMR5c0gx5rCU42C2DcuogrT4IXoo+IwJZlsoThkglEA3SUiuEw7xSq7/WnokQzE6ivmZS8+5udkNil+EG4lC3RhFibsorw/D2R6D7+218PavhlAro3ZdDQiAqCqDzV1/bC5zqa+tbR2YsmKZzKmn3chZtDFSxtfng3hxl4LijQTkrA5yXYQxMw9qOhD3bUF4Wz3K38joXAOheisHSxlP3Eid8TIU8uCMPK0vCGhtL+O7H2S8ZuawtiOK/G9FGKkFCI0CqtM6wrKA1JcVRNauRmusAO2iBdcd36BK9aDML1DKdMUoEQQLaTAhgNKJWfgG/wSJUFhhClelUB+PQjmVxtzha3jheQ+C2gTKOoEQFDwF5ME0TUNd3apfhcaphBOJATEVgxNJ2LMpREemQAISzEkd+koV00odThEJfY8WYPviCLUQiEr8vN9xwdRknPAlEnEXgexkGQf3evDh+1sx7HYBeQs9poZwEDh91o+CHQChCg60Z5CfdOEaZcA12qgkUYYFgKlWu+2PwJ630b8hhY3f+nDxgoEJshpPNE8hLhdgn41BL9iIN0rI/zENw2KQVBFMEZtgAIRzLgDfw8iIexZvDX10+9xErVgjINrdDHfBgF0xQLwSJMUHInmgXb0JsTkBl7OsvGzNvnDznmPAx2B3LM6njk/bhYAe3Zqs5Ytl2LoO4hVBmAKPxGFqJRjZRXjqQiDURWVWs7313CGEuPe5Jgo33qzt8EcsncNxBHBHgFnQAXBY2hKMqQJAGQihECSKaHcs7JGtnQ9JG3A7+0qm8hnjxYVgrVVlKFdFbjnU0BxeMR1fU9hRkopJvYZJw/G/HfGR/cHlDa/c4dldfau/V3LAgeqY/1bVnH0q2hROuronKClEYZIf5XnMSFB0Fl4/ZmVnB2KSURzNGHfxfwFFmcfh1PnWxwAAAABJRU5ErkJggg==" alt="备案" />
							&nbsp;沪公网安备 31010102005101号
						</span>
					</div>
					<div className="img-wrapper right">
						<a rel="noopener noreferrer">
							<img src={footer1} alt="上海工商" onClick={() => {
								window.open("http://scjgj.sh.gov.cn/", "_blank");
							}} />
						</a>
						<a rel="noopener noreferrer" href="https://sentinel.whitehatsec.eu/gateway/certified/confirmed.html?badge_key=9b493935-d84c-46da-b228-a342f2f173c2" target="_blank">
							<img src={footer3} alt="WhiteHat" />
						</a>
					</div>
				</div>
			</Footer>
		);
	}
}

export default DeskPageFooter;